import {Mapper} from '@s-ui/domain'

export class SeoModelDetailMetaInformationMapper extends Mapper {
  /**
   * replace blank space to _
   */
  _replaceSpaceToLowDash = value => String(value).replace(/\s/g, '_')

  /**
   * @constructor
   * @param {Object} deps
   * @param {Head} deps.seoDataValueObjectFactory
   * @param {SeoDataMapper} deps.seoDataMapper
   * @param {SeoLiteralMapper} seoLiteralMapper
   * @param {ProductStructuredDataSeoMapper} ProductStructuredDataSeoMapper
   * @param {Object} deps.config
   * */
  constructor({seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper, productStructuredDataSeoMapper, config}) {
    super()
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._productStructuredDataSeoMapper = productStructuredDataSeoMapper
  }

  /**
   * @method
   */
  async map({culture, pageName, params = {}}) {
    const {
      cons = [],
      image,
      logo,
      lowPrice,
      make,
      makeModel,
      makeSlug,
      model,
      modelSlug,
      month,
      pros = [],
      rating = [],
      year
    } = params

    const {MODEL_DETAIL_SEO} = this._config.get('seo')
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const siteUrl = `${protocol}${host}`

    const {H1, TITLE, META_DESCRIPTION, META_ROBOTS, CANONICAL} = MODEL_DETAIL_SEO[pageName][culture]

    const placeholderValues = {
      make,
      makeSlug,
      makeModel,
      model,
      modelSlug,
      currentMonth: month,
      currentYear: year,
      siteUrl
    }

    const parsedH1 = this._seoLiteralMapper.setText({text: H1}).setPlaceholderValues({placeholderValues}).map()

    const parsedTitle = this._seoLiteralMapper
      .setText({text: TITLE})
      .setPlaceholderValues({
        placeholderValues
      })
      .map()

    const parsedCanonical = this._replaceSpaceToLowDash(
      this._seoLiteralMapper
        .setText({text: CANONICAL})
        .setPlaceholderValues({
          placeholderValues
        })
        .map()
    )

    const parsedDescription = this._seoLiteralMapper
      .setText({text: META_DESCRIPTION})
      .setPlaceholderValues({
        placeholderValues
      })
      .map()

    const productStructuredDataVO = this._productStructuredDataSeoMapper.map({
      cons,
      description: parsedDescription,
      image,
      logo,
      lowPrice,
      make,
      model,
      name: parsedH1,
      pros,
      rating
    })

    const {
      links,
      metas,
      scripts,
      title: seoTitle
    } = this._seoDataMapper
      .title(parsedTitle)
      .canonical(parsedCanonical)
      .description(parsedDescription)
      .addSchemaData(productStructuredDataVO)
      .robots(META_ROBOTS)
      .map()

    return this._seoDataValueObjectFactory({
      h1: parsedH1,
      head: {
        link: links,
        meta: metas,
        scripts,
        title: seoTitle
      }
    })
  }
}
